<template>
  <div :class="$style.page">
    <Loading :loading="loading">
      <Title title="个人资料"></Title>

      <Item title="用户ID">
        <div :class="$style.fixed">{{ userInfo.id }}</div>
      </Item>
      <Item title="真实姓名">
        <div :class="$style.fixed">{{ userInfo.username }}</div>
      </Item>
      <Item title="昵称">
        <el-input v-model="nickname" />
      </Item>
      <Item title="性别">
        <el-radio v-model="sex" :label="0">男</el-radio>
        <el-radio v-model="sex" :label="1">女</el-radio>
      </Item>
      <Item title="出生日期">
        <el-date-picker v-model="birthday" type="date" placeholder="选择日期" />
      </Item>
      <Item title="联系电话">
        <div :class="$style.fixed">{{ userInfo.mobile }}</div>
      </Item>
      <Item title="Email">
        <div :class="$style.fixed">{{ userInfo.email }}</div>
      </Item>
      <Item title="联系QQ">
        <el-input v-model="qq" placeholder="请输入联系QQ" />
      </Item>
      <Item title="微信号">
        <el-input v-model="weixin" placeholder="请输入微信号" />
        <Button
          v-if="this.wechatUrl"
          :class="$style.look_btn"
          @click="setVisible(true)"
        >
          查看微信图片
        </Button>
        <UploadImage type="wx" :imageUrl="wechatUrl" @change="onFileChange" />
      </Item>
      <Item title="国家/地区" required>
        <el-select v-model="country" placeholder="请选择国家" value-key="id">
          <el-option
            v-for="item in countryList"
            :key="item.id"
            :label="item.countryNameCn"
            :value="item.countryNameCn"
          >
          </el-option>
        </el-select>

        <el-select
          v-if="country == '中国'"
          v-model="province"
          placeholder="请选择省份"
          value-key="id"
          @change="handleProvinceChange"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.id"
            :label="item.label"
            :value="item.label"
          >
          </el-option>
        </el-select>
        <el-select
          v-if="country == '中国'"
          v-model="city"
          placeholder="请选择城市"
          value-key="id"
          @change="handleCityChange"
        >
          <el-option
            v-for="item in cityList"
            :key="item.id"
            :label="item.label"
            :value="item.label"
          >
          </el-option>
        </el-select>
      </Item>
      <Item title="联系地址">
        <el-input
          :class="$style.width500"
          v-model="address"
          placeholder="请输入联系地址"
        />
      </Item>
      <Item title="公司名称">
        <el-input v-model="company" placeholder="请输入公司名称" />
      </Item>
      <Item title="邮政编码">
        <el-input
          :class="$style.width500"
          v-model="postCode"
          placeholder="请输入邮政编码"
        />
      </Item>
      <Item title="传真号码">
        <el-input
          :class="$style.width500"
          v-model="fax"
          placeholder="请输入传真号码"
        />
      </Item>
      <Item title=" ">
        <Button type="primary" :loading="loading" @click="clickSubmit">
          确认
        </Button>
      </Item>
    </Loading>

    <!-- 微信图片展示弹窗 -->
    <el-dialog
      :custom-class="$style.dialog_wx_img"
      title="图片浏览"
      :visible="visible"
      @close="setVisible(false)"
    >
      <img :class="$style.wx_img" :src="this.wechatUrl" alt="wxImg" />
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { getAddress, uploadImage, updateUserData } from "@server";

import { formatDate } from "@utils";

import UploadImage from "@components/UploadImage";

export default {
  name: "PersonalData",
  components: {
    UploadImage,
  },
  data() {
    return {
      country: "中国", // 国家
      countryList: [], // 国家列表
      provinceList: [], // 中国省市列表
      cityList: [], // 对应省市的城市列表

      file: null,
      visible: false,
      loading: false,

      nickname: "",
      sex: 0,
      birthday: "",

      province: "",
      city: "",

      qq: "",
      weixin: "",
      wechatUrl: "",
      address: "",
      company: "",
      postCode: "",
      fax: "",
    };
  },
  computed: {
    ...mapState("user", ["userInfo", "accountInfo", "amountInfo"]),
  },
  methods: {
    ...mapActions("user", ["getMemberInfoAction"]),

    async initData() {
      await this.getAddress();

      // 回显用户信息
      this.nickname = this.userInfo.nickname;
      this.sex = this.userInfo.sex;
      this.birthday = this.userInfo.birthday;
      this.province = this.userInfo.province;
      this.city = this.userInfo.city;
      this.qq = this.userInfo.qqNum;
      this.weixin = this.userInfo.wechatNum;
      this.wechatUrl = this.userInfo.url;
      this.address = this.userInfo.addr;
      this.company = this.userInfo.companyName;
      this.postCode = this.userInfo.postcode;
      this.fax = this.userInfo.fax;
    },

    async getAddress() {
      const res = await getAddress();
      const { code, data } = res;
      if (code === 200) {
        this.countryList = this.setIndexToId(data.countryList);
        this.provinceList = this.setIndexToId(data.distList);
        this.cityList = this.setIndexToId(data.distList[0].children);
      }
    },

    setIndexToId(arr) {
      // 为省份-城市列表生成id
      return arr.map((item, index) => ({ ...item, id: index }));
    },

    handleProvinceChange(val) {
      this.province = val;
      this.city = "";

      const cityList = this.provinceList.find(
        (item) => item.label === val
      )?.children;
      this.cityList = this.setIndexToId(cityList);
    },

    handleCityChange(val) {
      this.city = val;
    },

    onFileChange(data) {
      this.file = data.file;
      this.wechatUrl = data.imageUrl;
    },

    setVisible(v) {
      this.visible = v;
    },

    checkSubmit() {
      if (!this.nickname) {
        this.$message({ message: "请输入昵称!", type: "warning" });
        return false;
      }
      if (!this.province || !this.city) {
        this.$message({ message: "请选择省份-城市!", type: "warning" });
        return false;
      }

      return true;
    },

    async getSubmitData() {
      const data = {};
      const info = this.userInfo;

      // 获取微信图片参数图片
      if (this.file && this.wechatUrl !== this.userInfo.wechatUrl) {
        const formData = new FormData();
        formData.append("file", this.file);

        const res = await uploadImage(formData);
        if (res.code === 200) {
          this.wechatUrl = res.data.url;
          data.wechatImg = res.data.name;
        } else {
          return data;
        }
      }

      // 对比当前用户信息，不同的信息才提交修改
      this.nickname !== info.nickname && (data.nickname = this.nickname);
      this.sex !== info.sex && (data.sexNum = this.sex);
      this.birthday !== info.birthday &&
        (data.birth = formatDate(this.birthday));
      this.province !== info.province && (data.province = this.province);
      this.city !== info.city && (data.city = this.city);
      this.weixin !== info.wechatNum && (data.wechat = this.weixin);
      this.qq !== info.qqNum && (data.qqNum = this.qq);
      this.address !== info.addr && (data.addr = this.address);
      this.company !== info.companyName && (data.companyName = this.company);
      this.postCode !== info.postcode && (data.postcode = this.postCode);
      this.fax !== info.fax && (data.fax = this.fax);
      return data;
    },

    async clickSubmit() {
      if (!this.checkSubmit()) return;

      const data = await this.getSubmitData();
      if (Object.keys(data).length === 0) {
        this.$message({
          message: "请最少修改一项个人资料后再确认提交",
          type: "warning",
        });

        return;
      }

      this.loading = true;
      const res = await updateUserData(data);

      if (res.code == 200) {
        this.$message({ message: "修改成功", type: "success" });
        this.getMemberInfoAction();
      }
      this.loading = false;
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss" module scoped>
.page {
  min-height: rem(600);
  padding: rem(60);
  padding-top: 0;
  font-size: rem(16);
  color: #333;
  background: $white;
  box-shadow: $box-shadow;

  .fixed {
    width: rem(360);
    height: 40px;
    box-sizing: border-box;
    padding: 0 10px;
    line-height: 40px;
    font-size: rem(14);
    color: #333;
    border: $border-1;
    background-color: rgba(237, 242, 252, 0.5);
  }

  .look_btn {
    color: #666;
    background-color: $white;
    border: 1px solid #999;
    transition: all 0.24s;

    &:hover {
      color: $white;
      background-color: #999;
    }
  }

  :global {
    .gl-item {
      margin-bottom: rem(40);

      ::v-deep .gl-item__left {
        width: rem(100);
      }
    }

    .el-select {
      margin-right: rem(40);
    }

    .el-input {
      width: rem(360);
      margin-right: rem(40);
    }
  }

  .width500 {
    width: rem(500);
  }

  ::v-deep .dialog_wx_img {
    width: auto;

    .wx_img {
      width: 500px;
      object-fit: cover;
    }
  }
}
</style>
